// Authenticated calls to the Arlo server's JSON endpoints.

import { devicePrefs } from './device.ts';

export class ApiError extends Error {
  readonly status: number;
  constructor(message: string, status: number) {
    super(message);
    this.status = status;
  }
}

export function apiUrl(path: string): string {
  return `${devicePrefs().serverUrl}${path}`;
}

export async function api<T>(path: string, init: { method?: string; body?: unknown; signal?: AbortSignal } = {}): Promise<T> {
  const d = devicePrefs();
  const res = await fetch(apiUrl(path), {
    method: init.method ?? (init.body === undefined ? 'GET' : 'POST'),
    headers: { ...(init.body === undefined ? {} : { 'Content-Type': 'application/json' }), ...(d.key ? { Authorization: `Bearer ${d.key}` } : {}) },
    body: init.body === undefined ? undefined : JSON.stringify(init.body),
    signal: init.signal,
  });
  const json = (await res.json().catch(() => ({}))) as T & { error?: string };
  if (!res.ok) throw new ApiError(json.error ?? `Error ${res.status}`, res.status);
  return json;
}

export type KeyCheck = 'owner' | 'guest' | 'wrong' | 'no-server';

/** Try a household key against the server before relying on it. */
export async function checkKey(key: string, serverUrl = devicePrefs().serverUrl): Promise<KeyCheck> {
  try {
    const res = await fetch(`${serverUrl}/api/whoami`, { headers: { Authorization: `Bearer ${key.trim()}` } });
    if (res.status === 401 || res.status === 403) return 'wrong';
    if (!res.ok) return 'no-server';
    const json = (await res.json().catch(() => ({}))) as { role?: string };
    return json.role === 'guest' ? 'guest' : json.role === 'owner' ? 'owner' : 'no-server';
  } catch {
    return 'no-server';
  }
}
